(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[365],{

/***/ 52194:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impressum",
      function () {
        return __webpack_require__(13515);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ helper_image; }
});

// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
;// CONCATENATED MODULE: ./src/components/helper/serialize.js
function serialize(obj, prefix) {
    var str = [];
    var p;
    // eslint-disable-next-line no-restricted-syntax
    for(p in obj){
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? "".concat(prefix, "[").concat(p, "]") : p;
            var v = obj[p];
            str.push(v !== null && typeof v === 'object' ? serialize(v, k) : "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v)));
        }
    }
    return str.join('&');
}
/* harmony default export */ var helper_serialize = (serialize);

;// CONCATENATED MODULE: ./src/components/helper/image.js


var parse = function(photo, params) {
    var query = params || {};
    if (typeof photo === 'undefined' || !photo) {
        return '';
    }
    var p = photo;
    if (photo.indexOf('yachtsys.com') !== -1) {
        p = photo.replace('https://media.yachtsys.com', '/yachtsys');
    } else if (photo.indexOf('booking-manager.com') !== -1) {
        p = photo.replace('https://www.booking-manager.com', '/mmk');
    } else if (photo.indexOf('ws.nausys.com') !== -1) {
        p = photo.replace('https://ws.nausys.com', '/nausys');
    } else if (photo.indexOf('sednasystem.com') !== -1) {
        p = photo.replace('https://api1.sednasystem.com', '/sedna');
    } else if (photo.indexOf('api.chartercheck.com/fileadmin') !== -1) {
        p = photo.replace('https://api.chartercheck.com/fileadmin', '/fileadmin');
        if (!query.w) {
            query.w = 1500;
        }
    }
    if (/^(f|ht)tps?:\/\//i.test(p) && !/connect\.5-anker\./i.test(p)) {
        return p;
    }
    if (/^(f|ht)tps?:\/\//i.test(p) && /connect\.5-anker\./i.test(p)) {
        return "".concat(p, "?").concat(helper_serialize(params));
    }
    return "".concat(app_config/* default.endpoint */.Z.endpoint + p, "?").concat(helper_serialize(query));
};
/* harmony default export */ var helper_image = (parse);


/***/ }),

/***/ 89388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _components_helper_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1075);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SEO(param) {
    var _description = param.description, description = _description === void 0 ? '' : _description, _author = param.author, author = _author === void 0 ? 'Chartercheck' : _author, _meta = param.meta, meta = _meta === void 0 ? [] : _meta, _title = param.title, title = _title === void 0 ? 'Chartercheck' : _title, _canonicalUrl = param.canonicalUrl, canonicalUrl = _canonicalUrl === void 0 ? '' : _canonicalUrl, _image = param.image, image = _image === void 0 ? '' : _image, _robots = param.robots, robots = _robots === void 0 ? 'index, follow' : _robots;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pageImage = image ? (0,_components_helper_image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(image.publicUrl) : '';
    var canonicalUrlGen = canonicalUrl || router.asPath.split('?')[0];
    // prepend the base url to the canonical url
    if (canonicalUrlGen.indexOf('http') !== 0) {
        // remove first slash if it exists
        canonicalUrlGen = canonicalUrlGen.replace(/^\//, '');
        canonicalUrlGen = "".concat("https://www.chartercheck.com", "/").concat(canonicalUrlGen);
    }
    var metaData = [
        {
            name: 'robots',
            content: robots
        },
        {
            name: 'description',
            content: description
        },
        {
            property: 'og:site_name',
            content: 'Chartercheck'
        },
        {
            property: 'og:locale',
            content: router.locale
        },
        {
            property: 'og:author',
            content: author
        },
        {
            property: 'og:publisher',
            content: author
        },
        {
            property: 'og:title',
            content: title
        },
        {
            property: 'og:description',
            content: description
        },
        {
            property: 'og:type',
            content: 'website'
        },
        {
            property: 'og:url',
            content: router.asPath
        },
        {
            property: 'og:image',
            content: pageImage
        }, 
    ].filter(function(i) {
        return i.content;
    }).concat(meta);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                /*#__PURE__*/ children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrlGen
            }),
            metaData.map(function(props, k) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", _objectSpread({}, props), "meta-".concat(k));
            }),
            pageImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: pageImage
            })
        ]
    }));
};
SEO.defaultProps = {
    meta: [],
    description: ''
};


/***/ }),

/***/ 13515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Impressum; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_helper_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89388);
/* harmony import */ var _components_content_headline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17587);
/* harmony import */ var _app_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48387);




function Impressum() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_helper_seo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "Impressum | CharterCheck",
                description: "Hier finden Sie unser Impressum. Bei Fragen wenden Sie sich gerne jederzeit an unserer Servicehotline | Ihr Partner des ADAC"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-7xl mx-auto mt-header pt-10 px-6 xl:px-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-6 mb-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_headline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    tag: 1,
                                    children: "Impressum"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "CharterCheck GmbH"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "W\xfcrmstr. 4, 82319 Starnberg/M\xfcnchen, Deutschland",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Gesch\xe4ftsf\xfchrer: Martin K\xf6tje",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Registergericht: Amtsgericht M\xfcnchen",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Registernummer: HRB 185227",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "USt.-Identifikations-Nr: DE271073545",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Telefon:",
                                ' ',
                                _app_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].phone */ .Z.phone,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "E-Mail: booking@chartercheck.com",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_headline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    children: "Haftungshinweis"
                                }),
                                "Trotz sorgf\xe4ltiger inhaltlicher Kontrolle \xfcbernehmen wir keine Haftung f\xfcr die Inhalte externer Links. F\xfcr den Inhalt der verlinkten Seiten sind ausschlie\xdflich deren Betreiber verantwortlich."
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(52194); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);